import React from 'react';
import { NavLink } from 'react-router-dom';
import ENUMS from '../../enums';

export const contractList = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام',
    dataIndex: 'cafeName',
    name: 'cafeName',
    isSortable: true,
  },
  {
    title: 'مدیر کافه',
    dataIndex: 'cafeManagerName',
    name: 'cafeManagerName',
    isSortable: true,
  },
  {
    title: 'نوع کافه',
    dataIndex: 'cafeType',
    name: 'cafeType',
    isSortable: false,
  },
  {
    title: 'شماره قرارداد',
    dataIndex: 'contractNumber',
    name: 'contractNumber',
    isSortable: true,
  },
  {
    title: 'تاریخ عقد قرارداد',
    dataIndex: 'date',
    name: 'date',
    isSortable: true,
  },
  {
    title: 'زمان شروع قرارداد',
    dataIndex: 'startDate',
    name: 'startDate',
    isSortable: true,
  },
  {
    title: 'زمان پایان قرارداد',
    dataIndex: 'endDate',
    name: 'endDate',
    isSortable: true,
  },
  {
    title: 'عملیات',
    action: cafeContract => (
      <NavLink
        to={{
          pathname: '/cafes-contract/edit',
          contractId: cafeContract.id,
        }}
      >
        <i className='font-xlarge mx-1 text-success far fa-pen-square mx-2' />
      </NavLink>
    ),
  },
];
